import type { Sentry } from '@sonnen/web-utils';

let sentryInstance: Sentry | null = null;

export const setSentryInstance = (instance: Sentry | null) => {
  sentryInstance = instance;
};

export const getSentryInstance = (): Sentry | null => sentryInstance;

export const isSentryEnabled = (): boolean => sentryInstance !== null;
